(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/fraction-payment/assets/javascripts/pay-button-multiple-shares.js') >= 0) return;  svs.modules.push('/components/marketplace/fraction-payment/assets/javascripts/pay-button-multiple-shares.js');
"use strict";


const {
  useState
} = React;
const {
  Button
} = svs.ui;
const {
  ControlGroup,
  Select,
  Option
} = svs.ui.reactForm;
const {
  urlMapping
} = svs.core;

const PayButtonMultipleShares = _ref => {
  let {
    cantBuy,
    cantBuyReason,
    elemRef,
    fractionPurchaseLoading,
    isSmall,
    numberOfSharesLeft,
    onClick
  } = _ref;
  const [numberOfShares, setNumberOfShares] = useState(1);
  const selectNumberOfShares = noOfShares => {
    sessionStorage.setItem('pendingNumberOfShares', noOfShares);
    setNumberOfShares(noOfShares);
  };
  const getBuyButtonText = (cantBuy, cantBuyReason, fractionPurchaseLoading) => {
    const suffix = numberOfShares > 1 ? 'andelar' : 'andel';
    if (cantBuy && cantBuyReason) {
      return cantBuyReason;
    }
    if (fractionPurchaseLoading) {
      return 'Betalar..';
    }
    return "K\xF6p ".concat(numberOfShares, " ").concat(suffix);
  };
  const maxShares = Math.min(numberOfSharesLeft, 10);
  const numberOfSharesList = Array.from({
    length: maxShares
  }, (_, i) => i + 1);
  const numberOfSharesAsString = "".concat(numberOfShares);
  const isAuthenticated = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const currentReturnUrl = encodeURIComponent(location.pathname);
  const loginUrl = "".concat(urlMapping.get('loginHome'), "?returnUrl=").concat(currentReturnUrl);
  return React.createElement("section", {
    className: "pay-button-multiple-shares"
  }, React.createElement("p", {
    className: "select-description"
  }, "Antal:"), React.createElement(ControlGroup, {
    className: "margin-right-1",
    v2: true
  }, React.createElement(Select, {
    "aria-label": "Antal andelar",
    className: "margin-bottom-1 select-number-of-shares",
    "data-testid": "mkp-number-of-shares-select",
    disabled: cantBuy,
    name: "Antal andelar",
    onChange: event => {
      const value = Number(event.target.value);
      selectNumberOfShares(value);
    },
    v2: true,
    value: "".concat(numberOfShares)
  }, numberOfSharesList.map((noOfShares, index) =>
  React.createElement(Option, {
    key: "".concat(index, "_").concat(noOfShares),
    value: "".concat(noOfShares)
  }, "".concat(noOfShares))))), React.createElement(Button, {
    block: true,
    className: "pay-fraction-button qa-pay-fraction-button",
    "data-testid": "qa-pay-fraction-button",
    disabled: cantBuy,
    elemRef: elemRef,
    href: !isAuthenticated ? loginUrl : undefined,
    inverted: true,
    onClick: event => {
      if (isAuthenticated) {
        event === null || event === void 0 || event.preventDefault();
        event === null || event === void 0 || event.stopPropagation();
        onClick(numberOfShares);
        setNumberOfShares(1);
      }
    },
    onKeyDownCapture: event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.stopPropagation();
      }
    },
    size: isSmall ? 100 : 300
  }, getBuyButtonText(cantBuy, cantBuyReason, fractionPurchaseLoading)));
};
setGlobal('svs.components.marketplace.fractionPayment.PayButtonMultipleShares', PayButtonMultipleShares);

 })(window);